import React, { useState, useEffect } from "react";
import { Text, View, StyleSheet, Platform } from "react-native";

import Dialog from "../common/dialog";
import AppTheme from "../AppTheme";
import ManaButton from "../common/ManaButton";
import TrackBadgeIcon from "../common/icons/badges/TrackBadgeIcon";

export default function TrackBadgeCard({ isOpen = false, onPress }) {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  useEffect(() => {
    setIsDialogOpen(isOpen);
  }, [isOpen]);

  return (
    <>
      {isDialogOpen ? (
        <Dialog.Container>
          <View style={styles.container}>
            <View style={styles.card}>
              <View style={styles.header}>
                <Text style={styles.title}>Congratulations</Text>
              </View>

              {/* Content */}
              <View style={styles.cardContent}>
                <TrackBadgeIcon style={styles.image} />

                <Text style={styles.cardText}>You just earned</Text>
                <Text style={[styles.cardText, { color: "#41D3B0" }]}>
                  Time Keeper LV 1
                </Text>
              </View>

              <View style={styles.buttons}>
                <ManaButton
                  isMainButton
                  onPress={onPress}
                  style={styles.button}
                  styleText={styles.buttonText}
                  text={"Continue"}
                />
              </View>
            </View>
          </View>
        </Dialog.Container>
      ) : null}
    </>
  );
}

const styles = StyleSheet.create({
  container: {
    marginTop: -30,
    maxWidth: 320,
    marginHorizontal: "auto",
  },
  card: {
    backgroundColor: "#FFFFFF",
    borderRadius: 10,
    paddingBottom: 10,
    display: "flex",
    alignItems: "center",
  },
  header: {
    height: 50,
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: 24,
    marginBottom: 10,
  },
  title: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-SemiBold" }),
    fontWeight: "600",
    fontSize: 26,
    lineHeight: 35,
    letterSpacing: 0.5,
    color: "#2D3142",
    zIndex: 2,
    textAlign: "center",
  },
  cardContent: {
    display: "flex",
    alignItems: "center",
    paddingHorizontal: 10,
  },
  cardText: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-SemiBold" }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
    color: AppTheme.almostBlack,
    width: 180,
    textAlign: "center",
  },
  image: {
    width: 90,
    height: 116,
  },
  buttons: {
    marginTop: 28,
    maxWidth: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row",
    width: "100%",
  },
  button: {
    width: 150,
    paddingHorizontal: 20,
  },
});
